export default __webpack_public_path__ + "static/media/altImage.2255af70.png";